export default "__VITE_ASSET__o64LmkIA__"